import Link from 'next/link'
import { useTranslations } from 'next-intl'

import { useD9 } from '../../../hooks/use-d9-data'
import PdImage from '../../../components/pd-image/pd-image'
import { buildContactUsHref } from '../../../common/contact-us-link'

export function Section1() {
  const { section1 } = useD9()
  const t = useTranslations()

  return (
    <div className="relative w-full h-[177.9vw] laptop:h-[56.2vw] flex flex-col items-center">
      <div className="absolute left-0 top-0 right-0 bottom-0">
        <PdImage alt="bg" src={section1.backgroundImage} width="100%" height="100%" useLoader />
      </div>

      <div className="relative laptop:mt-115px mt-15 laptop:w-366px laptop:h-15 w-61 h-10">
        <PdImage src={section1.imageTitle} width="100%" height="100%" object="contain" />
      </div>

      <h2 className="relative laptop:mt-4 mt-12px text-white/90 laptop:text-2xl text-base font-normal px-4">
        {section1.subTitle}
      </h2>
      <div className="relative laptop:mt-6 mt-14px laptop:px-4 px-3 laptop:py-2 py-1 bg-[#f2f3f5] rounded-[19px] justify-center items-center gap-1 inline-flex">
        <Link href={buildContactUsHref('pudud9')} className="text-black/90 text-sm font-normal">
          {t('ContactUs')}
        </Link>
      </div>
    </div>
  )
}
